import { AxiosResponse } from 'axios';
import { ErrorResponse } from '@/core/api/error-response/error-response.class';

interface ErrorResponseBody {
  error: string;
  message: string;
}

export class ErrorResponseFromAps extends ErrorResponse {
  constructor(err: AxiosResponse) {
    super(err);
  }

  extractErrorCode(): string {
    const responseBody: ErrorResponseBody = this.getResponseBody();
    return responseBody.error;
  }
}
